//@flow
import React from 'react';

import withMargin from '../../../../../../../assets/img/main-banner/banner-with-margin.webp';
import withoutMargin from '../../../../../../../assets/img/main-banner/banner-without-margin.webp';
import {Button, makeStyles} from '@material-ui/core';
import {colors} from '../../../../../../../assets/styles/colors';
import {useFormContext} from 'react-hook-form';
import {MAIN_BANNER_FIELDS, BANNER_MARGIN_OPTIONS} from '../constants';

const useStyles = makeStyles(theme => ({
  items: {
    display: 'flex',
    gap: '.5rem',
    alignItems: 'center',
    justifyContent: 'center',
    flexWrap: 'wrap',
  },
  itemButton: {
    flexGrow: 1,
    padding: 0,
    textTransform: 'none',
    whiteSpace: 'nowrap',
    position: 'relative',
  },
  item: {
    width: '100%',
    height: '100%',
    background: '#F2F2F2',
    borderRadius: '.5rem',
    padding: '1.5rem 1rem 1rem 1rem',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    gap: '.75rem',
    cursor: 'pointer',
    position: 'relative',
  },
  itemLabel: {
    display: 'block',
    textAlign: 'center',
    color: colors.grey600,
    fontSize: '.75rem',
    fontWeight: 600,
  },
  layoutThumbnail: {
    width: '100%',
    maxWidth: '250px',
  },
  checkbox: {
    position: 'absolute',
    top: '.5rem',
    left: '.5rem',
    width: '1.25rem',
    height: '1.25rem',
    background: '#fff',
    borderRadius: '50%',
    border: '1px solid #E0E0E0',
    transition: 'border .2s ease-in-out',

    '&[data-checked=true]': {
      border: `.35rem solid ${colors.primary}`,
    },
  },
}));

const OPTIONS = [
  {
    name: BANNER_MARGIN_OPTIONS.WITH_MARGIN,
    image: withMargin,
    label: 'Con margenes',
  },
  {
    name: BANNER_MARGIN_OPTIONS.WITHOUT_MARGIN,
    image: withoutMargin,
    label: 'Sin margenes',
  },
];

export default function BannerMarginOption() {
  const classes = useStyles();

  const {setValue, watch} = useFormContext();

  const sizeSelected = watch(MAIN_BANNER_FIELDS.BANNER_MARGIN);

  return (
    <div className={classes.items}>
      {OPTIONS.map((option, index) => (
        <Button
          key={option.name}
          className={classes.itemButton}
          onClick={() => {
            setValue(MAIN_BANNER_FIELDS.BANNER_MARGIN, option.name);
          }}
        >
          <div className={classes.item}>
            <span className={classes.itemLabel}>{option.label}</span>
            <div
              className={classes.checkbox}
              data-checked={sizeSelected === option.name}
            ></div>
            <img
              className={classes.layoutThumbnail}
              src={option.image}
              alt={`dimension ${index}`}
            />
          </div>
        </Button>
      ))}
    </div>
  );
}
